import ProductNav from '../../common/ProductNav';
import { generalKey } from '../../config/pageConfig';
import NA_Product from './NA_Product';
import EU_Product from './EU_Product';
import JP_Product from './JP_Product';
import AU_Product from './AU_Product';
import getLocal from '@/app/utils/getLocal';
import './index.scss';
import EfScrollAni from '@/efscrollani';
import { getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import { useGlobal } from '@/utils/useGlobal';

export default function ExampleProductA() {
    const { locale = 'us' } = getLocal();
    const { gloproductlist } = useGlobal();
    const { buyLink } = getProductFromGeneralKey({ gloproductlist, generalKey });

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    return (
        <div className="page-product">
            <ProductNav activeTab={'Product'} buyLink={buyLink} />
            {['us', 'ca'].includes(locale) && <NA_Product />}
            {['eu', 'uk', 'de', 'fr', 'es', 'it'].includes(locale) && <EU_Product />}
            {['jp'].includes(locale) && <JP_Product />}
            {['au'].includes(locale) && <AU_Product />}
        </div>
    );
}
